import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/comics';

type ComicGridProps = {
  comics: Comic[];
  emptyText?: string;
  onReset?: () => void;
  emptyAction?: { label: string; to: string };
};

export default function ComicGrid({ comics, emptyText = '暂无符合筛选条件的漫画', onReset }: ComicGridProps) {
  if (comics.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
        <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-2xl text-foreground-400">
          <i className="ri-inbox-line" />
        </span>
        <p className="text-sm text-foreground-600">{emptyText}</p>
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="mt-4 flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-refresh-line" />
            重置筛选
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
      {comics.map((comic) => (
        <ComicCard key={comic.id} comic={comic} />
      ))}
    </div>
  );
}